import React, { useState } from 'react';
import ParentPanel from '../panel/ParentPanel'; 
import '../styles/RaiseATicket.css';
import api from "../../../api/api";

const RaiseATicket = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [issue, setIssue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Ticket submitted: ${issue}`);
    setIssue('');
  };

  return (
    <div className="raise-ticket-page">
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`ticket-container ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <h2 className="ticket-heading">Raise a Ticket</h2>
<p className="ticket-description">
  <span className="ticket-description-icon">💡</span>
  Facing an issue? Please provide all relevant details below so our support team can assist you quickly.
</p>


        <form onSubmit={handleSubmit} className="ticket-form">
          <label htmlFor="issue" className="ticket-label">Issue Description</label>
          <textarea
            id="issue"
            placeholder="Describe your issue..."
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
            rows={6}
            className="ticket-textarea"
          />

          <button type="submit" className="ticket-submit-btn">
            Submit Ticket
          </button>
        </form>
      </div>
    </div>
  );
};

export default RaiseATicket;
